import {
  CentroAutoTransferProfile,
  isCentroAutoTransferConfigReady,
  isCentroAutoTransferSourceCampaign as isCentroJsonSourceCampaign,
  resolveCentroAutoTransferProfile,
} from './centro-auto-transfer-config';

export type { CentroAutoTransferProfile } from './centro-auto-transfer-config';

export function getCentroAutoTransferProfile(): CentroAutoTransferProfile {
  const empty: CentroAutoTransferProfile = {
    enabled: false,
    targetAgentId: '',
    targetCampaign: '',
    loginCampaign: '',
  };
  try {
    const raw = localStorage.getItem('remarks');
    if (!raw) return empty;
    const details = JSON.parse(raw)?.centroDetails || {};
    const loginCampaign = String(
      details.campaignName ||
        details.CampaignName ||
        details.campaignId ||
        details.CampaignId ||
        ''
    ).trim();
    const agentId = String(details.agentId || details.AgentId || details.agentID || '').trim();
    if (!loginCampaign || !agentId) return empty;
    return resolveCentroAutoTransferProfile(agentId, loginCampaign);
  } catch {
    return empty;
  }
}

export function isCentroAutoTransferSourceCampaign(campaignName: string): boolean {
  return isCentroJsonSourceCampaign(campaignName);
}

export function isCentroAutoTransferReady(): boolean {
  return isCentroAutoTransferConfigReady();
}
